import { useSearchParams } from 'react-router-dom';

export default function withRouterSearchParamsHooks(Component) {
    return function WrappedComponent(props) {
        const searchParams = useSearchParams();
        return <Component searchParams={searchParams} {...props} />;
    };
};